import * as React from 'react'
import styled from 'styled-components'
import { ConfiguratorBox } from 'src/components/containers/configurator/ConfiguratorBox'
import { ConfiguratorText } from 'src/components/atoms/configurator'
import { media } from 'src/utils.js'

export default class Advantages extends React.Component<any> {
  render() {
    return (
      <ConfiguratorBox>
        <h2>Ihre Vorteile bei Benu</h2>
        <TopText>
          Benu ist für Sie in ganz Österreich tätig und zeichnet sich durch
          allerhöchste Kundenzufriedenheit aus.
        </TopText>
        <ListContainer className='product-long-desc'>
          <ul>
            <li>Transparentes Angebot ohne versteckte Kosten</li>
            <li>Hervorragendes Preis-Leistungs-Verhältnis</li>
            <li>Kostenfreie und professionelle Beratung</li>
            <li>Einfach und ganz in Ruhe von zu Hause</li>
          </ul>
        </ListContainer>
      </ConfiguratorBox>
    )
  }
}

const TopText = styled(ConfiguratorText)`
  margin: 15px auto;
  text-align: center;
`

const ListContainer = styled.div`
  & > ul > li {
    display: inline-block;
    padding-right: 7.5px;
    text-align: left;
  }

  ${media.giant`
    & > ul {
      width: 75%;
      margin: auto;
      columns: 2;
      padding-left: 0 !important;
      text-align: center;
    }
    & > ul > li {
      margin: 0 7.5px 10px 0 !important;
    }
  `}
  ${media.tablet`
    & > ul {
      margin: auto;
      columns: 1;
      padding-left: unset;
      text-align: center;
    }
    & > ul > li {
      margin: unset;
      padding-right: 0;
    }
  `}
  ${media.largePhone`
    & > ul {
      width: unset;
      text-align: left;
    }
  `}
`



// WEBPACK FOOTER //
// ./src/components/organisms/configurator/Advantages.tsx